// import React from 'react';
// import { Box, Container, Typography } from '@mui/material';
// import Grid from '@mui/material/Grid2';

// import './FooterComponent.css';

// const footerData = [
//     ['מיזמי תשתיות לאומיים', 'תשתיות לצמיחה', 'הון אנושי לתשתיות'],
//     ['מערכת תיאום תשתיות לאומיות', 'אסדרה בתחומי התשתיות', ''],
//     ['הצהרת נגישות', 'תנאי שימוש', 'שימוש בקבצי “cookies"'],
//     ['צרו קשר', 'govil@israel.co.il', 'רח\' קפלן 3, ירושלים'],
// ];

// const FooterComponent = () => {
//     return (
//         <Box className="FooterBox" component="footer">
//             <Container maxWidth={false}>
//                 <Grid container spacing={2} alignItems="flex-start" justifyContent="space-between">

//                     {/* Text Columns */}
//                     <Grid size={8}>
//                         <Grid container spacing={4} sx={{justifyContent: 'space-between'}}>
//                             {footerData.map((column, colIdx) => (
//                                 <Grid key={colIdx} size={{ xs: 6, sm: 3 }}>
//                                     {column.map((item, rowIdx) => (
//                                         <Typography key={rowIdx} className="FooterText">
//                                             {item}
//                                         </Typography>
//                                     ))}
//                                 </Grid>
//                             ))}
//                         </Grid>
//                     </Grid>

//                     {/* Image on the left */}
//                     <Grid>
//                         <Box className="FooterLogosContainer">
//                             <img
//                                 src="/images/footer.png"
//                                 alt="logo"
//                                 className="FooterLogo"
//                             />
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Container>
//         </Box>
//     );
// };

// export default FooterComponent;


import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import './FooterComponent.css';

const footerData = [
  ['הצהרת נגישות', 'תנאי שימוש', 'שימוש בקבצי “cookies"'],
  ['צרו קשר', 'infrastructure@pmo.gov.il', "כתובת: משרד ראש הממשלה, רח' קפלן 3, קריית בן גוריון, ירושלים"]
];

const FooterComponent = () => {
  return (
    <Box className="FooterBox" component="footer">
      <Container maxWidth={false}>
        <div className="FooterContentWrapper">
          <div className="FooterColumn">
            <Typography className="FooterText"><a href={'https://www.gov.il/he/pages/foundation081024'}>מידע נוסף על האתר</a></Typography>
              <Typography className="FooterText"><a href={'https://www.gov.il/he/pages/accessibility-statement'}>הצהרת
              נגישות</a></Typography>
            <Typography className="FooterText"><a href={'https://www.gov.il/he/pages/gov_terms_of_use'}>תנאי
              שימוש</a></Typography>
            <Typography className="FooterText"><a href={'https://www.gov.il/he/pages/using_files_cookies'}>שימוש בקבצי
              “cookies"</a></Typography>
          </div>
          <div className="FooterColumn">
            <Typography className="FooterText">צרו קשר</Typography>
            <Typography className="FooterText"><a href="mailto:infrastructure@pmo.gov.il">infrastructure@pmo.gov.il</a></Typography>
            <Typography className="FooterText">כתובת: משרד ראש הממשלה, רח' קפלן 3, קריית בן גוריון, ירושלים</Typography>
          </div>

          <div className="FooterLogosContainer">
            <img
                src="/images/roam-footer.png"
                alt="לוגו משרד ראש הממשלה"
                className="FooterLogo"
            />
            <img
                src="/images/nec-footer.png"
                alt="לוגו המועצה הלאומית לכלכלה"
                className="FooterLogo"
            />
            <img
                src="/images/inda-footer.png"
                alt="לוגו מערך הדיגיטל הלאומי"
                className="FooterLogo"
            />
          </div>
        </div>
      </Container>
    </Box>
  );
};

export default FooterComponent;

